"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = exports.overridesAUS = void 0;
var translations = {
    en: {
        common: {
            sprnGas: 'MPRN',
            sprnGasFull: 'Meter Point Reference Number',
            sprnElec: 'MPAN',
            sprnElecFull: 'Meter Point Administration Number',
            msn: 'MSN',
            msnFull: 'Meter Serial Number',
            costUnit: '£',
            costFull: 'Cost',
            kwhUnit: 'kWh',
            kwhFull: 'Kilowatt hour',
            elecFuel: 'Electricity',
            gasFuel: 'Gas',
            bothFuels: 'Both',
            retailer: 'Orion',
            cancel: 'Cancel',
            contactUs: 'contact us',
            back: 'Back',
            submit: 'Submit',
            confirm: 'Confirm',
            save: 'Save',
            edit: 'Edit',
            next: 'Next',
            ev: 'EV',
            inverter: 'solar inverter',
            evFull: 'Electric Vehicle',
            registerAnytime: 'anytime',
            registerPeak: 'peak',
            registerOffPeak: 'off-peak',
            registerSuperOffPeak: 'Super off-peak',
            registerEvOffPeak: 'EV off-peak',
            registerHeating: 'heating',
            registerEveningAndWeekend: 'evening & weekend',
            registerSolar: 'solar',
            registerInterval: 'smart',
            registerShoulder: 'shoulder',
            registerControlledLoad: 'controlled load',
            energySourceFossil: 'fossil fuels',
            energySourceRenewable: 'renewables',
            energySourceHomeSolar: 'home solar',
            legalCompanyName: 'LEGAL COMPANY NAME',
            directDebitUserID: 'DD USER ID',
            directDebitDisplayName: 'DD DISPLAY NAME',
            directDebitMerchantName: 'DD MERCHANT NAME',
        },
    },
};
exports.translations = translations;
var overridesAUS = {
    common: {
        sprnGas: 'MIRN',
        sprnGasFull: 'Meter Identification Reference Number',
        sprnElec: 'NMI',
        sprnElecFull: 'National Meter Identifier',
        costUnit: '$',
        legalCompanyName: 'LEGAL COMPANY NAME',
        directDebitUserID: 'DD USER ID',
        directDebitDisplayName: 'DD DISPLAY NAME',
        directDebitMerchantName: 'DD MERCHANT NAME',
    },
};
exports.overridesAUS = overridesAUS;
